﻿$(document).ready(function () {
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");

    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");

      $(close_btn).on("click", () => {
        parent_section.hide();
        document.body.classList.add("announcement-hide");
      });
    });
  }
});

// Announcement bar slides rotation
document
  .querySelectorAll("[data-announcement-slides]")
  .forEach(function (slidesWrapper) {
    var slides = slidesWrapper.querySelectorAll(".announcement-bar__slide");
    if (slides.length <= 1) return;
    var current = 0;
    setInterval(function () {
      slides[current].classList.remove("announcement-bar__slide--active");
      current = (current + 1) % slides.length;
      slides[current].classList.add("announcement-bar__slide--active");
    }, 4000);
  });

// Announcement bar slides rotation
document
  .querySelectorAll("[data-announcement-slides]")
  .forEach(function (slidesWrapper) {
    var slides = slidesWrapper.querySelectorAll(".announcement-bar__slide");
    if (slides.length <= 1) return;
    var current = 0;
    setInterval(function () {
      slides[current].classList.remove("announcement-bar__slide--active");
      current = (current + 1) % slides.length;
      slides[current].classList.add("announcement-bar__slide--active");
    }, 4000);
  });
